<template>
  <section>
    <div class="title">{{ title }}</div>
    <flicking
      ref="flicking"
      class="flicking flicking0"
      :options="{ hanger: 0, anchor: 0, gap: 8, moveType: 'snap', renderExternal:true, useOffset: false}"
    >
      <div v-for="(item, index) in items" :key="index" class="panel">
        <a :href="item.outlink" target="_blank" @click="handleClick">
          <div class="anchor" :style="styleCss(item.img)"></div>
          <div class="badges">
            <Badge v-for="(skill, idx) in item.stack" :key="idx" :text="skill" />
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </a>
      </div>
    </flicking>
  </section>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking"
import Badge from "../components/ui/badge"
import { eventBus } from "../main"

export default {
  components: { Flicking, Badge },
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: []
    }
  },
  watch: {
    items(val, oldVal) {
      console.log(val, oldVal)
      this.$nextTick(() => {
        console.log(this.$refs.flicking.getAllPanels())
      })
    }
  },
  methods: {
    handleClick(e) {
      if (this.$refs.flicking.isPlaying()) {
        e.preventDefault()
      }
    },
    styleCss(bg) {
      return {
        backgroundImage: `url(${bg})`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  & > .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    letter-spacing: -1px;
  }

  .flicking {
  }

  .panel {
    width: calc(100% - 32px);
    max-width: 300px;
    .anchor {
      width: 100%;
      height: 200px;
      background-size: cover;
      background-position: 50% 22%;
      margin-bottom: 8px;
    }
    .title {
      color: #000000;
      letter-spacing: -1px;
      font-weight: bold;
      margin-top: 8px;
    }
    .desc {
      color: #343434;
    }
  }
}
a,
a:hover {
  text-decoration: none;
}
</style>
